var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    {
      staticStyle: { height: "calc(100vh - 80px)", overflow: "scroll" },
      attrs: { fluid: "" }
    },
    [
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", "max-width": "290" },
          model: {
            value: _vm.delDialog,
            callback: function($$v) {
              _vm.delDialog = $$v
            },
            expression: "delDialog"
          }
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-text", [
                _vm._v("Are you sure you want to delete this officer?")
              ]),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      staticClass: "elc-button-radius",
                      attrs: { flat: "" },
                      nativeOn: {
                        click: function($event) {
                          _vm.delDialog = false
                        }
                      }
                    },
                    [_vm._v("Cancel")]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      staticClass: "elc-button-radius-color",
                      attrs: { flat: "" },
                      nativeOn: {
                        click: function($event) {
                          _vm.deleteOfficer()
                        }
                      }
                    },
                    [_vm._v("OK")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "elc-card-club-count" },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "p-10" },
                [
                  _c(
                    "v-layout",
                    { attrs: { wrap: "" } },
                    [
                      _c("v-flex", { attrs: { xs12: "", md8: "" } }, [
                        _c(
                          "span",
                          {
                            staticStyle: {
                              "font-weight": "500",
                              "font-size": "22px",
                              color: "#596363"
                            }
                          },
                          [_vm._v("ELC Officers ")]
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        { attrs: { xs12: "", md3: "" } },
                        [
                          _c("v-text-field", {
                            attrs: {
                              "append-icon": "search",
                              label: "Search",
                              "single-line": "",
                              "hide-details": ""
                            },
                            model: {
                              value: _vm.search,
                              callback: function($$v) {
                                _vm.search = $$v
                              },
                              expression: "search"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        {
                          staticClass: "text-xs-right",
                          attrs: { xs12: "", md1: "" }
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "p-l-10 p-r-10" },
                            [
                              _c(
                                "v-tooltip",
                                { attrs: { bottom: "" } },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "elc-button-rounded",
                                      attrs: { slot: "activator", fab: "" },
                                      on: {
                                        click: _vm.redirectToAddNewOfficer
                                      },
                                      slot: "activator"
                                    },
                                    [
                                      _c("v-icon", { attrs: { dark: "" } }, [
                                        _vm._v("add")
                                      ])
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("span", [_vm._v("Add Officer")])
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-data-table",
                {
                  staticClass: "elc-deta-table fixed-header1",
                  attrs: {
                    headers: _vm.headers,
                    items: _vm.officerDetails,
                    loading: _vm.loading,
                    "hide-actions": "",
                    "disable-initial-sort": true,
                    "no-data-text": _vm.loading ? "" : "No officers available"
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "items",
                      fn: function(props) {
                        return [
                          _c(
                            "td",
                            {
                              staticClass: "elc-capital",
                              staticStyle: { cursor: "pointer !important" },
                              on: {
                                click: function($event) {
                                  _vm.openDetailDialog(props.item)
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(props.item.name) +
                                  "\n                        "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "td",
                            {
                              staticStyle: { cursor: "pointer !important" },
                              on: {
                                click: function($event) {
                                  _vm.openDetailDialog(props.item)
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    _vm.constant.rolePrefix_const[
                                      props.item.officer_role
                                    ]
                                  ) +
                                  "\n                    "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          props.item.election_id != null
                            ? _c(
                                "td",
                                {
                                  staticStyle: { cursor: "pointer !important" },
                                  on: {
                                    click: function($event) {
                                      _vm.openDetailDialog(props.item)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(props.item.election_id) +
                                      "\n                    "
                                  )
                                ]
                              )
                            : _c("td", [_vm._v("-")]),
                          _vm._v(" "),
                          props.item.email != null
                            ? _c(
                                "td",
                                {
                                  staticStyle: { cursor: "pointer !important" },
                                  on: {
                                    click: function($event) {
                                      _vm.openDetailDialog(props.item)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(props.item.email) +
                                      "\n                    "
                                  )
                                ]
                              )
                            : _c("td", [_vm._v("-")]),
                          _vm._v(" "),
                          props.item.dob != 0
                            ? _c(
                                "td",
                                {
                                  staticStyle: { cursor: "pointer !important" },
                                  on: {
                                    click: function($event) {
                                      _vm.openDetailDialog(props.item)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(props.item.dob) +
                                      "\n                    "
                                  )
                                ]
                              )
                            : _c("td", [_vm._v("-")]),
                          _vm._v(" "),
                          _c(
                            "td",
                            {
                              staticStyle: { cursor: "pointer !important" },
                              on: {
                                click: function($event) {
                                  _vm.openDetailDialog(props.item)
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(props.item.phone) +
                                  "\n\n                    "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "td",
                            {
                              staticStyle: { cursor: "pointer !important" },
                              on: {
                                click: function($event) {
                                  _vm.openDetailDialog(props.item)
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(props.item.pincode) +
                                  "\n\n                    "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          props.item.area != null
                            ? _c(
                                "td",
                                {
                                  staticStyle: { cursor: "pointer !important" },
                                  on: {
                                    click: function($event) {
                                      _vm.openDetailDialog(props.item)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(props.item.area) +
                                      "\n                    "
                                  )
                                ]
                              )
                            : _c("td", [_vm._v("-")]),
                          _vm._v(" "),
                          _c(
                            "td",
                            {
                              staticStyle: { cursor: "pointer !important" },
                              on: {
                                click: function($event) {
                                  _vm.openDetailDialog(props.item)
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(props.item.district) +
                                  "\n\n                    "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "td",
                            { staticStyle: { cursor: "pointer !important" } },
                            [
                              _c(
                                "v-menu",
                                {
                                  attrs: {
                                    transition: "slide-x-transition",
                                    bottom: "",
                                    right: ""
                                  }
                                },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: { slot: "activator", icon: "" },
                                      slot: "activator"
                                    },
                                    [_c("v-icon", [_vm._v("more_horiz")])],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-list",
                                    [
                                      _c(
                                        "v-list-tile",
                                        {
                                          on: {
                                            click: function($event) {
                                              _vm.openEditDialog(props.item)
                                            }
                                          }
                                        },
                                        [
                                          _c("v-list-tile-title", [
                                            _vm._v(
                                              "\n                                        Edit\n                                    "
                                            )
                                          ])
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-list-tile",
                                        {
                                          on: {
                                            click: function($event) {
                                              _vm.openDelDialog(props.item)
                                            }
                                          }
                                        },
                                        [
                                          _c("v-list-tile-title", [
                                            _vm._v(
                                              "\n                                        Delete\n                                    "
                                            )
                                          ])
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ]
                      }
                    }
                  ])
                },
                [
                  _c(
                    "v-alert",
                    {
                      attrs: {
                        slot: "no-results",
                        value: true,
                        color: "error",
                        icon: "warning"
                      },
                      slot: "no-results"
                    },
                    [
                      _vm._v(
                        '\n                    Your search for "' +
                          _vm._s(_vm.search) +
                          '" found no results.\n                '
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.totalCount > _vm.count
                ? [
                    _c(
                      "div",
                      {
                        staticClass: "text-xs-center pt-2",
                        staticStyle: {
                          position: "fixed",
                          bottom: "50px",
                          width: "96vw"
                        }
                      },
                      [
                        _c("v-pagination", {
                          attrs: {
                            color: "#515a75",
                            circle: "",
                            length: _vm.totalPage,
                            "total-visible": 7
                          },
                          on: { input: _vm.pagination },
                          model: {
                            value: _vm.page,
                            callback: function($$v) {
                              _vm.page = $$v
                            },
                            expression: "page"
                          }
                        })
                      ],
                      1
                    )
                  ]
                : _vm._e()
            ],
            2
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.addEditFlag
        ? _c(
            "div",
            [
              _c("add-officer", {
                attrs: {
                  editObj: _vm.editOfficer,
                  officerDialog: _vm.addOfficerDialog,
                  addEditFlag: _vm.addEditFlag
                },
                on: {
                  closeOfficerDialog: _vm.cancelOfficerDialog,
                  saveOfficer: _vm.saveOfficer,
                  updateOfficer: _vm.updateOfficer
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.detailFlag
        ? _c(
            "div",
            [
              _c("officer-details-dialog", {
                attrs: {
                  editObj: _vm.editOfficer,
                  officerDialog: _vm.addOfficerDialog,
                  detailShowFlag: _vm.detailFlag
                },
                on: {
                  closeOfficerDialog: _vm.cancelOfficerDialog,
                  saveOfficer: _vm.saveOfficer,
                  updateOfficer: _vm.updateOfficer
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.addFlag
        ? _c(
            "div",
            [
              _c("add-officer", {
                attrs: {
                  officerDialog: _vm.addOfficerDialog,
                  addEditFlag: _vm.addEditFlag
                },
                on: {
                  closeOfficerDialog: _vm.cancelOfficerDialog,
                  saveOfficer: _vm.saveOfficer,
                  updateOfficer: _vm.updateOfficer
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("alert-modal", {
        attrs: { alertMsg: _vm.msg, alertMsgDialog: _vm.alertDialog },
        on: {
          closeAlert: function($event) {
            _vm.alertDialog = false
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-cfd71416", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cfd71416","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Officer/OfficerDetails.vue
// module id = null
// module chunks = 